import {
  BaseEndpointBuilder,
  endpointBuilder,
} from '@squareup/dex-data-shared-base-api';
import { Flags } from '@squareup/dex-types-shared-developer-api';

const DOCS_V2__API_URL = '/v2/api';
const reducerPath = 'connectv2DocsApi';
const appName = 'connectv2-docs';

/**
 * All endpoints for the connect v2 docs.
 */
const endpointsFactory = (
  builder: BaseEndpointBuilder<typeof reducerPath>
) => ({
  // TODO: Are flags user/merchant or any other specific partition?
  // For now we arent passing but we will want this partitioned so need to pass the token etc.
  getFlags: builder.query<Flags, void>({
    query: () => ({
      path: `${DOCS_V2__API_URL}/flags`,
      appName,
    }),
  }),
});
const endpoints = endpointsFactory(endpointBuilder);

export { endpoints, endpointsFactory, reducerPath };
